// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"main_wrapper__1v3E6","table-container":"main_table-container__9ykNB","button-wrapper":"main_button-wrapper__135R-"};